/** Shared Razorpay Checkout loader (Phase D/N). */

export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
    document.body.appendChild(script);
  });
}

export async function openRazorpayCheckout({
  checkout,
  description,
  onSuccess,
  onDismiss,
  onFailed,
}) {
  const Razorpay = await loadRazorpayScript();
  const options = {
    key: checkout.key_id || checkout.razorpay_key_id,
    amount: checkout.amount,
    currency: checkout.currency,
    order_id: checkout.razorpay_order_id,
    name: 'RESQLY',
    description,
    handler: onSuccess,
    modal: {
      ondismiss: onDismiss,
    },
    webview_intent: true,
  };
  const rzp = new Razorpay(options);
  if (onFailed) {
    rzp.on('payment.failed', onFailed);
  }
  rzp.open();
  return rzp;
}
